module.exports = __webpack_public_path__ + "static/react-a49a66ecf79f7ba36a3209dd6ecafc41.png";